import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import './chatTheme.css';

interface ExecutiveInsights {
  periodo: string;
  totalAtendimentos: number;
  resolvidos: number;
  abertos: number;
  slaCumpridoPercentual: number;
  tempoMedioRespostaMin: number;
  tempoMedioResolucaoMin: number;
  satisfacaoMedia: number;
  principaisCategorias: Array<{ categoria: string; total: number }>;
  alertas: Array<{ titulo: string; severidade: 'BAIXA' | 'MEDIA' | 'ALTA'; descricao: string }>;
}

export function ChatExecutiveInsightsDashboard() {
  const [data, setData] = useState<ExecutiveInsights | null>(null);
  const [periodo, setPeriodo] = useState('30d');

  useEffect(() => {
    api.get('/chat-interno/insights/executivo', { params: { periodo } })
      .then((res) => setData(res.data));
  }, [periodo]);

  if (!data) return <div className="p-4 text-sm text-muted-foreground">Carregando visão executiva...</div>;

  const cards = [
    ['Atendimentos', data.totalAtendimentos],
    ['Resolvidos', data.resolvidos],
    ['Abertos', data.abertos],
    ['SLA cumprido', `${data.slaCumpridoPercentual}%`],
    ['Resposta média', `${data.tempoMedioRespostaMin} min`],
    ['Resolução média', `${data.tempoMedioResolucaoMin} min`],
    ['Satisfação', data.satisfacaoMedia.toFixed(1)],
  ];

  return (
    <div className="ac-chat-v8-panel">
      <div className="ac-chat-v8-card">
        <h3 className="ac-chat-command-label">Visão executiva</h3>
        <select className="ac-chat-v8-select" value={periodo} onChange={(e) => setPeriodo(e.target.value)} style={{ marginTop: 10 }}>
          <option value="7d">Últimos 7 dias</option>
          <option value="30d">Últimos 30 dias</option>
          <option value="90d">Últimos 90 dias</option>
          <option value="ano">Ano atual</option>
        </select>
      </div>

      <div className="ac-chat-command-grid">
        {cards.map(([label, value]) => (
          <div key={String(label)} className="ac-chat-command-card">
            <p className="ac-chat-command-label">{label}</p>
            <h3 className="ac-chat-command-value">{value}</h3>
          </div>
        ))}
      </div>

      <div className="ac-chat-v8-card">
        <h3 className="ac-chat-command-label">Principais categorias</h3>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
          {data.principaisCategorias.map((item) => (
            <span key={item.categoria} className="ac-chat-category-pill">{item.categoria}: {item.total}</span>
          ))}
        </div>
      </div>

      <div className="ac-chat-v8-card">
        <h3 className="ac-chat-command-label">Alertas executivos</h3>
        <div style={{ display: 'grid', gap: 8, marginTop: 12 }}>
          {data.alertas.map((alerta) => (
            <div key={alerta.titulo} className="ac-chat-automation-box">
              <p className="ac-chat-automation-title">{alerta.severidade} · {alerta.titulo}</p>
              <p className="ac-chat-automation-text">{alerta.descricao}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
